// extracted by mini-css-extract-plugin
module.exports = {"content":"IntegrationTransactionListHeader_content__4zZ1e","button":"IntegrationTransactionListHeader_button__JWwYF"};